import { ApiPaginationBody } from "../../../types/pagination";
import { getAxiosClient } from "../../axios-client";
import { GetAllWarehousesResponse } from "./types";

const axiosClient = getAxiosClient();
export const getAllWarehouses = async (body: ApiPaginationBody) => {
  return await axiosClient.ax.post<GetAllWarehousesResponse>(
    "/Warehouses/GetAll",
    body
  );
};
